import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  FaTachometerAlt,
  FaChartLine,
  FaUsers,
  FaCog,
  FaSignOutAlt,
  FaGlobe,
  FaDatabase
} from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import Swal from 'sweetalert2';

const Sidebar = ({ variant = 'desktop' }) => {
  const isTablet = variant === 'tablet';
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const navigationItems = [
    { path: '/dashboard', label: 'Dashboard', icon: FaTachometerAlt },
    { path: '/analytics', label: 'Analytics', icon: FaChartLine },
    { path: '/masters', label: 'Masters', icon: FaDatabase },
    { path: '/users', label: 'Users', icon: FaUsers },
    { path: '/settings', label: 'Settings', icon: FaCog },
  ];

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will be logged out of your account',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, logout',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
        Swal.fire('Logged out!', 'You have been successfully logged out.', 'success');
      }
    });
  };

  return (
    <div className={`${
      isTablet ? 'w-20 group hover:w-64' : 'w-64'
    } min-h-screen bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-700 flex flex-col transition-all duration-300`}>
      {/* Logo Section */}
      <div className={`${isTablet ? 'p-4 pb-6' : 'p-6 pb-8'}`}>
        <div className="flex items-center gap-3">
          <FaGlobe className="w-8 h-8 text-purple-600 flex-shrink-0" />
          <h1 className={`${
            isTablet ? 'w-0 group-hover:w-auto opacity-0 group-hover:opacity-100' : 'w-auto opacity-100'
          } text-xl font-bold text-purple-600 transition-all duration-300 overflow-hidden whitespace-nowrap`}>
            Community of Hubs
          </h1>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1 px-4">
        <ul className="space-y-1">
          {navigationItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) => `
                    flex items-center gap-3 px-4 py-3 mx-2 rounded-lg transition-all duration-200
                    ${isActive
                      ? 'bg-purple-100 dark:bg-purple-900/50 text-purple-600'
                      : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                    }
                  `}
                >
                  <Icon className="w-5 h-5 flex-shrink-0" />
                  <span className={`${
                    isTablet ? 'w-0 group-hover:w-auto opacity-0 group-hover:opacity-100' : 'w-auto opacity-100'
                  } font-medium transition-all duration-300 overflow-hidden whitespace-nowrap`}>
                    {item.label}
                  </span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Bottom Section - User Info & Logout */}
      <div className="mt-auto border-t border-gray-200 dark:border-gray-700 p-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
            <span className="text-purple-600 font-semibold text-sm">
              A
            </span>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-900 dark:text-white">
              Admin User
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              Admin
            </p>
          </div>
        </div>

        <button
          onClick={handleLogout}
          className="flex items-center w-full px-4 py-3 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-all duration-200 gap-3"
        >
          <FaSignOutAlt className="w-5 h-5" />
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;